import { CameraNotificationStatus, CameraNotificationType } from '@EcamModel/model/CameraNotification';
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../hooks/NotificationProvider';
import LayoutNotificationItem, { NotificationItemProps } from './LayoutNotificationItem';

export default function BaseNotificationItem(props: NotificationItemProps) {
    const navigate = useNavigate();
    const { markRead, handleClose } = useNotification();
    const { item, index, customNote } = props;

    const isUnread = item?.Status === CameraNotificationStatus.Unread;

    const pathNameMappingByType = {
        [CameraNotificationType.Task]: {
            pathName: '/task-management',
            state: { cameraName: item?.Camera?.Name, created: item?.Created },
        },
        [CameraNotificationType.PhotoOverload]: {
            pathName: `/cameras/${item?.CameraId}`,
            state: {},
        },
        [CameraNotificationType.PTZPositionMismatch]: {
            pathName: `/cameras/${item?.CameraId}`,
            state: {},
        },
        [CameraNotificationType.CameraDisconnected]: {
            pathName: `/cameras/${item?.CameraId}`,
            state: {},
        },
        [CameraNotificationType.LowCameraPhoto]: {
            pathName: `/cameras/${item?.CameraId}`,
            state: {},
        },
        [CameraNotificationType.HighCameraPhoto]: {
            pathName: `/cameras/${item?.CameraId}`,
            state: {},
        },
        [CameraNotificationType.LowCameraBattery]: {
            pathName: `/cameras/${item?.CameraId}`,
            state: {},
        },
    };

    const handleMarkRead = () => {
        isUnread && markRead([item?.Id!]);
        handleClose();
        navigate(`${pathNameMappingByType[item?.Type]?.pathName}`, {
            state: pathNameMappingByType[item?.Type]?.state,
        });
    };

    return (
        <LayoutNotificationItem
            handleMarkRead={handleMarkRead}
            index={index}
            item={item}
            children={<Typography>{customNote || item?.Notes}</Typography>}
            title={`Camera: ${item?.Camera?.Name}`}
        />
    );
}
